<template>
  <div>
    <v-progress-linear
      indeterminate
      v-if="config_horarios.carregando"
    ></v-progress-linear>
    <template v-else>
      <v-row>
        <v-col cols="12">
          <v-dialog v-model="dialog" max-width="550" persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                rounded
                v-on="on"
                v-bind="attrs"
                class="mb-2"
                :block="isMobile()"
                ><v-icon left>mdi-pencil</v-icon>Editar</v-btn
              >
            </template>
            <v-card>
              <v-card-title class="font-weight-bold">Horário Base</v-card-title>
              <v-card-text>
                <v-select
                  :items="
                    config_horarios.dados.horario_padrao.filter(
                      (hp) => hp.exibir
                    )
                  "
                  item-text="desc_dia"
                  item-value="dia_semana"
                  multiple
                  label="Dia semana"
                  deletable-chips
                  chips
                  v-model="config_horarios.hora_base.dias_semana"
                ></v-select>

                <v-row>
                  <v-col md="6" cols="12">
                    <v-text-field
                      label="Formações até as:"
                      type="time"
                      v-model="config_horarios.hora_base.hora_lim"
                    ></v-text-field>
                  </v-col>
                  <v-col md="6" cols="12">
                    <v-text-field
                      label="Carregamento a partir das:"
                      type="time"
                      v-model="config_horarios.hora_base.hora_prox_carreg"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-if="config_horarios.retorno.erro">
                    <v-col cols="12">
                        <v-alert text type="error">{{config_horarios.retorno.msg}}</v-alert>
                    </v-col>
                </v-row>

              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  text
                  class="font-weight-bold"
                  rounded
                  :loading="config_horarios.salvando"
                  @click="confirmarHorarios()"
                  :disabled="config_horarios.hora_base.dias_semana.length == 0"
                  >Confirmar horários</v-btn
                >
                <v-btn
                  @click="dialog = false"
                  text
                  rounded
                  :disabled="config_horarios.salvando"
                  >Fechar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-card flat rounded="lg">
            <v-card-title class="grey lighten-5 subtitle-1 font-weight-bold"
              >Horário Base <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="pt-5">
              <v-data-table
                :items="
                  config_horarios.dados.horario_padrao.filter((hp) => hp.exibir)
                "
                :headers="headers"
                hide-default-footer
                disable-sort
              >
                <template v-slot:[`item.desc_dia`]="{ item }">
                  <span class="font-weight-bold">{{ item.desc_dia }}</span>
                </template>
                <template v-slot:[`item.desc_prox_dia`]="{ item }">
                  <v-select
                    :items="item.dias_carreg"
                    item-text="descricao"
                    item-value="prox"
                    v-model="item.prox_dia"
                    no-data-text="Não há dias disponíveis"
                    @change="alterarProxDia()"
                  ></v-select>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: mapState("formacaoCarga", ["config_horarios"]),
  watch: {
    dialog: function (open) {
      if (open) {
        this.config_horarios.hora_base.dias_semana = "";
        this.config_horarios.hora_base.hora_lim = "";
        this.config_horarios.hora_base.hora_prox_carreg = "";
        this.config_horarios.retorno.msg = ""
        this.config_horarios.retorno.erro = false
      }
    },
  },
  data: () => ({
    dialog: false,        
    headers: [
      { text: "Formações realizadas no dia", value: "desc_dia" },
      { text: "até as (hora lim)", value: "hora_lim" },
      { text: "carregam a partir das", value: "hora_prox_carreg" },
      {
        text: "após hora lim, carregar na(o)",
        value: "desc_prox_dia",
        width: 230,
      },
      { text: "", value: "actions" },
    ],
  }),
  methods: {
    ...mapActions("formacaoCarga", ["buscarHorarios", "salvarHorarios"]),
    isMobile() {
      return this.$mq == "sm";
    },  
    async confirmarHorarios() {
      this.config_horarios.editou_prox_dia = false;
      if (await this.salvarHorarios()) {
        await this.buscarHorarios();
        this.dialog = false;
      }
    },
    async alterarProxDia() {
      this.config_horarios.editou_prox_dia = true;
      if (await this.salvarHorarios()) {
        await this.buscarHorarios();
        this.dialog = false;
      }
    },
  },
  async mounted() {
    await this.buscarHorarios();
  },
};
</script>

<style>
</style>